import { render } from "./RequestDetailsView.vue?vue&type=template&id=2ab5d5c6&scoped=true"
import script from "./RequestDetailsView.vue?vue&type=script&lang=js"
export * from "./RequestDetailsView.vue?vue&type=script&lang=js"

import "./RequestDetailsView.css?vue&type=style&index=0&id=2ab5d5c6&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ab5d5c6"]])

export default __exports__